/**
 * "Approve and post": the approval step marks the request, the publish control
 * on the finished screen takes the mark once and opens the publish (or connect)
 * path. sessionStorage so a reload mid-approve still finds it; silent when
 * storage is unavailable, which just means a plain approve.
 */
const key = (requestId: string) => `outpost:post-after-approve:${requestId}`;

export function markPostAfterApprove(requestId: string): void {
  try {
    sessionStorage.setItem(key(requestId), '1');
  } catch {
    // Storage blocked: the approve still happens, the post is one click away.
  }
}

/** True once per mark; clears it. */
export function takePostAfterApprove(requestId: string): boolean {
  try {
    const marked = sessionStorage.getItem(key(requestId)) === '1';
    if (marked) sessionStorage.removeItem(key(requestId));
    return marked;
  } catch {
    return false;
  }
}
